import InputTextMatSmall from "../../../../../components/common/InputText/InputTextMatSmall";
import ButtonOutlineWithIcon from "../../../../../components/common/buttons/ButtonOutlineWithIcon";
import PlusIcon from ".//..//..//..//..//..//assets//images//icons//plus.svg";
import BinIcon from ".//..//..//..//.//..//..//assets//images//icons//bin-light.svg";
import StreetViewIcon from ".//..//..//..//.//..//..//assets//images//icons//streetview.png";
import GmapPlaceSearchBox from "../../../../../components/calculator/GmapPlaceSearch/GmapPlaceSearchBox";
import { useEffect, useState } from "react";
import { numbersInHungarian } from "../../../../../constants/HungraianNumbers";
import { useSelector } from "react-redux";
import StartLocationCreate from "./StartLocationCreateModel";
import Select from "react-select";

const TripPlanner = ({
  updateMap,
  distances,
  destinations,
  addDestination,
  removeDestination,
  searchChange,
  totalDistance,
  startLocations,
  pushStartLocation,
  getStreetView,
}) => {
  const updateDestination = (
    streetNumber,
    route,
    country,
    locality,
    postalCode,
    placeId,
    name,
    address,
    lat,
    lng,
    index,
    start_index
  ) => {
    updateMap(
      streetNumber,
      route,
      country,
      locality,
      postalCode,
      placeId,
      name,
      address,
      lat,
      lng,
      index,
      start_index
    );
  };

  console.log(distances);

  const updateStartLocation = (e) => {
    setDefaultStartLocation(e);
    const stLocation = startLocations[e.value];
    console.log(stLocation);
    updateDestination(
      stLocation?.streetNumber,
      stLocation?.route,
      stLocation?.country,
      stLocation?.locality,
      stLocation?.postalCode,
      stLocation?.place_id,
      stLocation?.helyszin_neve,
      stLocation?.cim,
      stLocation?.latitude,
      stLocation?.longitute,
      0,
      e.value
    );
  };
  const [firsttry, setFirstTry] = useState(0);
  const [startLocationArr, setStartLocationArr] = useState([]);
  const [defaultStartLocation, setDefaultStartLocation] = useState("");
  const [streetviewClicked, setStreetViewClicked] = useState(-99);
  useEffect(() => {
    const arr = [];
    startLocations.map((startLocation, index) => {
      arr.push({
        value: index,
        label: startLocation.cim,
      });
    });
    setStartLocationArr(arr);
  }, [startLocations]);

  useEffect(() => {
    if (firsttry == 0) {
      if (destinations.length > 0) {
        console.info(destinations[0]);
        setDefaultStartLocation({
          value: destinations[0]?.start_index,
          label: destinations[0]?.address,
        });
        setFirstTry(firsttry + 1);
      }
    }
  }, [destinations]);

  const displayDistanceInKm = (distanceInMeters) => {
    let roundedNumber = parseFloat(distanceInMeters.toFixed(2)).toString();
    return roundedNumber;
  };

  const streetView = (index, place) => {
    getStreetView(index, place);
    if (streetviewClicked == index) {
      setStreetViewClicked(-99);
    } else {
      setStreetViewClicked(index);
    }
  };

  const getInterDistance = (placeId) => {
    const interDistance = distances?.filter(
      (item) => item?.endDestination === placeId
    )[0]?.distanceBetween;
    //  setInterDistance(interDistance, placeId, index);
    return interDistance;
  };

  const renderDestinations = () => {
    return destinations.slice(1).map((item, index) => {
      const interdistance = getInterDistance(item?.placeId);
      return (
        <li className="flex flex-col gap-[1.6rem]" key={index + (index + 1)}>
          <InputTextMatSmall
            label={`Köztes kilóméter`}
            readOnly={true}
            value={interdistance}
          />
          <div className="flex flex-row justify-center w-full gap-2 ">
            <div className="w-full">
              <GmapPlaceSearchBox
                label={`${numbersInHungarian[index + 1]} cím`}
                index={index + 1}
                value={item?.address}
                onChange={(e) => searchChange(e.target.value, index + 1)}
                updateDestination={updateDestination}
              />
            </div>
            <div className="flex items-end justify-center gap-2">
              <button
                onClick={() => removeDestination(index + 1, item?.placeId)}
                className="bg-[#065567] cursor-pointer flex items-center justify-center h-[3.125rem] w-[3.125rem] rounded-[0.675rem]"
              >
                <img src={BinIcon} className={`w-[1.6rem]`} />
              </button>
              <button
                onClick={() => streetView(index + 1, item)}
                className={` bg-[#065567] cursor-pointer flex items-center justify-center h-[3.125rem] w-[3.125rem] rounded-[0.675rem]`}
              >
                <img
                  src={StreetViewIcon}
                  className={`w-[1.6rem] ${
                    streetviewClicked == 1 ? "rotate-12" : ""
                  } `}
                />
              </button>
            </div>
          </div>
        </li>
      );
    });
  };

  return (
    <>
      <div className="mt-5 ps-2 pe-4">
        <StartLocationCreate pushStartLocation={pushStartLocation} />
        <ul className="flex flex-col mt-4 mb-7 gap-[1.6rem]">
          <li key={"11111"}>
            <div className="flex flex-row justify-center w-full gap-2 ">
              <div className="w-full">
                <div className="border-[1px]  relative rounded-[0.3rem] transition-all ease-in-out duration-100  border-[#79747E] focus:border-[#79747E] outline-0 font-lato text-[1rem] w-full leading-normal p-2">
                  <Select
                    classNames={`border-[0px] outline-0 drop-shadow-none`}
                    options={startLocationArr}
                    value={defaultStartLocation}
                    onChange={(e) => updateStartLocation(e)}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "#9dbbc2",
                        primary: "#095567",
                      },
                    })}
                  />
                  <label className="absolute font-normal text-[0.75rem] -translate-y-1/2 -top-[2px] left-4 bg-white px-2 font">
                    Indulási cím
                  </label>
                </div>
              </div>
              <div className="flex items-end justify-center gap-2">
                <button
                  onClick={() => {
                    if (destinations.length > 0) {
                      streetView(0, destinations[0]);
                    }
                  }}
                  className="bg-[#065567] cursor-pointer flex items-center justify-center h-[3.125rem] w-[3.125rem] rounded-[0.675rem]"
                >
                  <img
                    src={StreetViewIcon}
                    className={`w-[1.6rem] ${
                      streetviewClicked == 0 ? "rotate-12" : ""
                    } `}
                  />
                </button>
              </div>
            </div>
          </li>

          {renderDestinations()}
        </ul>
        <ButtonOutlineWithIcon
          label={"Cím hozzáadása"}
          icon={PlusIcon}
          onClick={addDestination}
        />
        <div className="flex justify-between items-center mt-7 bg-[#0655671a] p-4">
          <span className="text-[1.5rem] font-poppins text-secondary-color font-extrabold leading-normal">
            Összesen
          </span>
          <span className="text-[1.5rem] font-poppins text-secondary-color font-extrabold leading-normal">
            {totalDistance > 1000
              ? displayDistanceInKm(totalDistance / 1000)
              : totalDistance}{" "}
            {totalDistance > 1000 ? "km" : "m"}
          </span>
        </div>
      </div>
    </>
  );
};

export default TripPlanner;
